<div
  (click)="updateFooterMenuWithState()"
  [nbSpinner]="!sidebarInitialized"
  nbSpinnerStatus="basic"
  style="height: -webkit-fill-available"
>
  <nb-menu
    *ngIf="sidebarInitialized && currentSidebarConfig"
    #mainSidebarMenu
    tag="mainMenu"
    [items]="currentSidebarConfig"
    [ngClass]="{ 'font-weight-light': 1, 'main-sidebar': 1 }"
    id="nav-step3"
  >
  </nb-menu>
</div>
